import React from 'react'

class ScrollMonitor extends React.Component{

  componentDidMount() {
    this.scrollStopTimeout = null
    this.scrollProxy = document.getElementById('scroll-proxy')
    this.startLoop()
    this.currentAutoPlayFrame = null
    this.scrollProxy.addEventListener('touchmove', function(event){
        event.stopPropagation();
    }, {passive: true});

  }

  shouldComponentUpdate(){
    return false
  }

  componentWillUnmount() {
    this.stopLoop()
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.scrollValue){
      this.stopLoop()
      const scrollHeight = parseInt(document.getElementById('scroll-proxy').style.height, 10) - window.innerHeight
      const percentage = (nextProps.scrollValue / this.props.sceneData.frameCount)
      window.scrollTo(0, (scrollHeight * percentage) + 3)
    }
    if(!this.loadProgress !== 100 && nextProps.loadProgress){
      this.percentComplete = this.completionPercentageFromLoad(nextProps.loadProgress)
    }
  }

  completionPercentageFromLoad(loadProgress){
    let completeCount = 0
    loadProgress.forEach((progress) => {
      if(progress === 1){
        completeCount++
      }
    })
    return(completeCount / this.props.sceneData.scenes.length / 2 * 100)
  }


  startLoop() {
    if( !this._frameId ) {
      this._frameId = window.requestAnimationFrame( this.loop.bind(this) )
    }
  }

  update(){
    const scrollValue = this.getScrollPercent()
    const data = this.frameDataFromPercentage(scrollValue)
    this.broadcastScroll(data.frameNumber, data.type)
    if(data.type === 'advance'){
      const scrollHeight = parseInt(document.getElementById('scroll-proxy').style.height, 10) - window.innerHeight
      const percentage = (data.frameNumber / this.props.sceneData.frameCount)
      window.scrollTo(0, (scrollHeight * percentage) + 3)
    }
  }

  frameDataFromPercentage(percentage){
    if(percentage > this.percentComplete){
      percentage = this.percentComplete
      const scrollHeight = parseInt(document.getElementById('scroll-proxy').style.height, 10) - window.innerHeight
      window.scrollTo(0, (scrollHeight * percentage) + 3)
    }
    this.lastFrameNumber = percentage
    const frameNumber = this.props.sceneData.frameCount * (percentage / 100)
    return {
      type: this.getTypeFromFrameNumber(frameNumber),
      frameNumber: frameNumber,
    }
  }

  getTypeFromFrameNumber(frameNumber){
    const autoPlayPoints = this.props.sceneData.autoPlayPoints
    let type = 'scroll'
    autoPlayPoints.forEach((autoPlayPoint) => {
      if(frameNumber >= autoPlayPoint.startFrame && frameNumber < autoPlayPoint.endFrame){
        type = 'advance'
      }
    })
    return type
  }

  broadcastScroll(scrollValue, type){
    if(scrollValue === this.lastScrollValue){
      return
    }
    this.lastScrollValue = scrollValue
    const event = {
      scrollValue: scrollValue,
      type: type,
    }
    this.props.scrollChangeHandler(event)
  }

  getScrollPercent() {
    return (this.getScrollPosition() * 100);
  }

  getScrollHeightByPercentage(percentage){
    return((document.documentElement.scrollTop + document.body.scrollTop) * (percentage / 100))
  }

  getScrollPosition(){
    return((document.documentElement.scrollTop + document.body.scrollTop) /
          (this.scrollProxy.scrollHeight - document.documentElement.clientHeight))
  }

  setScrollPosition(position){
    window.scrollTo(0, position);
  }

  loop() {
    this.update()
    this.frameId = window.requestAnimationFrame( this.loop.bind(this) )
  }

  stopLoop() {
    window.cancelAnimationFrame( this._frameId )
  }

  render(){
    return(
      <div id="scroll-proxy" style={ scrollStyle() }></div>
    )
  }
}

export default ScrollMonitor


function scrollStyle(){
  return({
    'width': '100%',
    'height': '20000px',
    'backgroundColor': 'rgba(1,1,0,0.001)',
    overflow: 'hidden',
  })
}



// WEBPACK FOOTER //
// ./src/ScrollMonitor.js